import { lazy } from 'react';
import PageHeader from '@/components/common/PageHeader.jsx';
import { FaBullhorn } from 'react-icons/fa6';
import { FaUsers } from 'react-icons/fa6';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaNewspaper } from 'react-icons/fa6';
import FAQPage from '@/pages/faq/FAQPage';
const MembershipPage = lazy(() =>
  import('@/pages/community/membership/MembershipPage.jsx')
);

const SchedulePage = lazy(() =>
  import('@/pages/community/programs/SchedulePage.jsx')
);
const ScheduleEditPage = lazy(() =>
  import('@/pages/community/programs/ScheduleEditPage.jsx')
);
const ScheduleDetailPage = lazy(() =>
  import('@/pages/community/programs/ScheduleDetailPage.jsx')
);
const NewsDetailPage = lazy(() =>
  import('@pages/community/news/NewsDetailPage.jsx')
);
const NewsEditPage = lazy(() =>
  import('@pages/community/news/NewsEditPage.jsx')
);

const NewsLetterPage = lazy(() =>
  import('@/pages/community/newsletter/NewsPage.jsx')
);
const NewsLetterDetailPage = lazy(() =>
  import('@/pages/community/newsletter/NewsDetailPage.jsx')
);
const NewsLetterEditPage = lazy(() =>
  import('@/pages/community/newsletter/NewsEditPage.jsx')
);
const NewsPage = lazy(() => import('@pages/community/news/NewsPage.jsx'));
const NoticePage = lazy(() => import('@pages/community/notice/NoticePage.jsx'));
const NoticeEditPage = lazy(() =>
  import('@pages/community/notice/NoticeEditPage.jsx')
);
const NoticeDetailPage = lazy(() =>
  import('@pages/community/notice/NoticeDetailPage.jsx')
);
const isMobile = window.innerWidth <= 768;

const communityRouter = () => {
  return [
    { path: 'news', element: <NewsPage /> },
    { path: 'news/create', element: <NewsEditPage /> },
    { path: 'news/edit/:id', element: <NewsEditPage /> },
    { path: 'news/:id', element: <NewsDetailPage /> },
    { path: 'notices', element: <NoticePage /> },
    { path: 'notices/create', element: <NoticeEditPage /> },
    { path: 'notices/edit/:id', element: <NoticeEditPage /> },
    { path: 'notices/:id', element: <NoticeDetailPage /> },
    {
      path: 'membership',
      element: <MembershipPage />,
    },
    { path: 'events', element: <SchedulePage /> },
    { path: 'events/create', element: <ScheduleEditPage /> },
    { path: 'events/edit/:id', element: <ScheduleEditPage /> },

    { path: 'events/:id', element: <ScheduleDetailPage /> },
    { path: 'newsletter', element: <NewsLetterPage /> },
    { path: 'newsletter/create', element: <NewsLetterEditPage /> },
    { path: 'newsletter/:id', element: <NewsLetterDetailPage /> },
    { path: 'newsletter/edit/:id', element: <NewsLetterEditPage /> },
    {
      path: 'faq',
      element: <FAQPage />,
    },
  ];
};

export default communityRouter;
